import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
import SampleTable from "./SampleTable"

import {
  Check,
  ConfirmModal2,
  CustomAutoComplete,
  CustomButton,
  CustomSelectAsync,
  TitleAndTable,
  WarningModal
} from "components/Common"

import {
  convertStringForSearch,
  selectCheckboxHandler
} from "helpers/utilities"

import { AvForm } from "availity-reactstrap-validation"
import { ModuleIds, SAMPLES_DELIVERY_TYPE, parameterCode, permissionType } from "constant"
import {
  addDeliverySample,
  deleteDeliverySample,
  getDeliveryAllTests,
  getDeliveryDetail,
  getDeliverySamples,
  searchDeliverySampleDetail,
  updateDeliverySamples,
  updateMassDeliverySamples
} from "store/actions"
import CustomSearchBar from "../TabTest/SearchBar"

const RESOURCE = ModuleIds.DeliveryManagement

const TabSample = ({
  deliveryId,
  deliveryType,
  samples,
  loadingSamples,
  updatedSampleTime,
  onGetDeliverySamples,
  delivery,
  onSearchDeliverySampleDetail,
  t,
  onDelete,
  onSubmit,
  isCollapse,
  enableBarcode,
  resource,
  userPermissions,
  generalSettingObject
}) => {
  const [saveConfirmModal, setSaveConfirmModal] = useState(false)
  const [row, setRow] = useState({})
  const [rows, setRows] = useState([])
  const [warningModal, setWarningModal] = useState(false)
  const [dataTable, setDataTable] = useState([])
  const [model, setModel] = useState({
  })
  const [reason, setReason] = useState({})
  const [method, setMethod] = useState({})

  useEffect(() => {
    if (samples) {
      setDataTable(samples)
    } else {
      setRows([])
    }
  }, [samples])

  const onDeleteHandler = (sample) => {
    onDelete(sample)
  }

  const onMultiDeleteHandler = () => {
    if (rows.length === 0) {
      setWarningModal(true)
    } else {
      onDelete(rows)
      setRows([])
    }
  }

  const toggleConfirmSaveSample = () => {
    setSaveConfirmModal(!saveConfirmModal)
  }

  const onSelectCheckbox = (row, isSelected) => {
    const { rowsState, currentRow } = selectCheckboxHandler(
      rows,
      row,
      isSelected
    )
    setRows(rowsState)
    setRow(currentRow)
  }

  const onSelectAllCheckbox = rows => {
    setRows(rows)
    if (rows.length < 1) setRow({})
    else setRow(rows[rows.length - 1])
  }

  const changeRemarkHandler = (value, sample) => {
    dataTable.forEach((item) => {
      if (item.sampleId === sample.sampleId
        && item.sampleType === sample.sampleType
        && item.patientId === sample.patientId
        && item.subSID === sample.subSID) {
        item.remark = value
      }
    })
  }

  const onChangeQuality = (value, sample) => {
    let newData = [...dataTable]
    newData.forEach((item) => {
      if (item.sampleId === sample.sampleId
        && item.sampleType === sample.sampleType
        && item.patientId === sample.patientId
        && item.subSID === sample.subSID) {
        item.qualityName = value.label
        item.quality = value.code
      }
    })
  }

  const onChangeQuantity = (value, sample) => {
    let newData = [...dataTable]
    newData.forEach((item) => {
      if (item.sampleId === sample.sampleId
        && item.sampleType === sample.sampleType
        && item.patientId === sample.patientId
        && item.subSID === sample.subSID) {
        item.quantity = value
      }
    })
  }

  const onChangeMethod = (value, sample) => {
    let newData = [...dataTable]
    newData.forEach((item) => {
      if (item.sampleId === sample.sampleId
        && item.sampleType === sample.sampleType
        && item.patientId === sample.patientId
        && item.subSID === sample.subSID) {
        item.methodName = value.label
        item.method = value.code
      }
    })
  }

  const onChangeReason = (value, sample) => {
    dataTable.forEach((item) => {
      if (item.sampleId === sample.sampleId
        && item.sampleType === sample.sampleType
        && item.patientId === sample.patientId
        && item.subSID === sample.subSID) {
        item.reason = value.value
        item.reasonName = value.label
      }
    })
  }

  const onReasonChange = (value) => {
    dataTable.forEach(item => {
      item.reason = value.code
      item.reasonName = value.label
    })
    setDataTable([...dataTable])
    setReason(value)
  }

  const onMethodChange = (value) => {
    dataTable.forEach(item => {
      item.method = value.code
      item.methodName = value.label
    })
    setDataTable([...dataTable])
    setMethod(value)
  }

  const onSaveSample = () => {
    onSubmit(dataTable)
  }

  const onSearchChange = value => {
    model.search = value
  }

  const onSearchClear = () => {
    model.search = ""
    setModel({ ...model })
  }

  const onSearchSubmit = e => {
    e.preventDefault()
    setModel({ ...model })
  }

  let dataFilter = dataTable
  if (model.search) {
    const searchConvert = convertStringForSearch(model.search)
    dataFilter = dataFilter.filter(item => convertStringForSearch(item?.sidName?.toString())?.includes(searchConvert)
      || convertStringForSearch(item?.sampleTypeName).includes(searchConvert)
      || convertStringForSearch(item?.patientName)?.includes(searchConvert)
      || convertStringForSearch(item?.sampleType)?.includes(searchConvert))
  }

  return (
    <React.Fragment>
      <TitleAndTable
        resource={resource}
        table={() => (
          <SampleTable
            resource={resource}
            data={dataFilter}
            deliveryType={deliveryType}
            onSelect={onSelectCheckbox}
            onSelectAll={onSelectAllCheckbox}
            onDelete={onDeleteHandler}
            loading={loadingSamples}
            model={model}
            updatedTime={updatedSampleTime}
            onChangeRemark={changeRemarkHandler}
            onChangeQuality={onChangeQuality}
            onChangeReason={onChangeReason}
            onChangeMethod={onChangeMethod}
            delivery={delivery}
            userPermissions={userPermissions}
            onChangeQuantity={onChangeQuantity}
            isCollapse={isCollapse}
            generalSettingObject={generalSettingObject}
            onSubmit={(val) => {
              onGetDeliverySamples(deliveryId, () => {
                onSearchDeliverySampleDetail({ searchText: val })
              })
            }}
            customButtonTable={() => (
              <AvForm>
                <div className="d-flex" style={{ width: '800px', justifyContent: 'right' }}>
                  <CustomSearchBar
                    onSearch={onSearchChange}
                    searchText={model.search}
                    placeholder={`${t('Name')}, SID...`}
                    onClear={onSearchClear}
                    onSubmit={onSearchSubmit}
                    disabled={enableBarcode}
                  />
                  {deliveryType === SAMPLES_DELIVERY_TYPE.Correction
                    && <div style={{ width: "27%" }} className="mx-1">
                      <CustomAutoComplete
                        name="reasonCorrection"
                        emptySelect
                        portal
                        value={reason.code || null}
                        errorMessage={""}
                        isClearable={false}
                        code={parameterCode.REASON_KEY}
                        label={t("")}
                        placeholder={t("Reason")}
                        onChange={(e, value, item) => {
                          onReasonChange({ code: item[0].value, label: item[0].label })
                        }}
                      />
                    </div>}
                  {(deliveryType === SAMPLES_DELIVERY_TYPE.Delivery || deliveryType === SAMPLES_DELIVERY_TYPE.Receipt || deliveryType === SAMPLES_DELIVERY_TYPE.DeliveryAndReceipt)
                    && <div style={{ width: "26%" }} className="mx-1">
                      <CustomSelectAsync
                        name="method"
                        value={method.code}
                        errorMessage={""}
                        code={parameterCode.METHOD_DELIVERY}
                        label={t("")}
                        required
                        placeholder={t("Method")}
                        onChange={(e, value, label) => {
                          onMethodChange({ code: value[0], label: label })
                        }}
                      />
                    </div>}
                  <CustomButton
                    color="primary"
                    outline
                    onClick={onMultiDeleteHandler}
                    disabled={dataTable.length === 0}
                    style={{ height: "37px" }}
                  >
                    {t("common:Delete")}
                  </CustomButton>

                  <Check permission={permissionType.C} resource={resource}>
                    {deliveryType !== SAMPLES_DELIVERY_TYPE.Cancelation
                      && <CustomButton
                        style={{ height: "37px" }}
                        color="success"
                        onClick={onSaveSample}
                        isEdit
                        disabled={dataTable?.length === 0}
                      >
                        {t("common:Save")}
                      </CustomButton>}
                  </Check>
                </div>
              </AvForm>
            )}
          />
        )}
        icon={false}
        external
      />
      <WarningModal
        modal={warningModal}
        onToggle={() => setWarningModal(prev => !prev)}
        message={t("message:SelectRowWarning")}
      />

      <ConfirmModal2
        modal={saveConfirmModal}
        title={`${t("common:Save")} ${t("common:Sample")}`}
        message={t("SaveSampleConfirm")}
        onToggle={toggleConfirmSaveSample}
        btnConfirmText={t("common:Save")}
      />
    </React.Fragment>
  )
}

TabSample.propTypes = {
  deliveryId: PropTypes.string.isRequired,
  samples: PropTypes.array,
  loadingSamples: PropTypes.bool,
  updatedSampleTime: PropTypes.any,
  onEditDeliverySamples: PropTypes.func,
  qualityOptions: PropTypes.array,
  t: PropTypes.any,
  onGetDeliveryDetail: PropTypes.func,
}

TabSample.defaultProps = {}

const mapStateToProps = ({ sampleDelivery, Authorization, generalSetting }) => ({
  requestSamples: sampleDelivery.requestSamples,
  loadingSamples: sampleDelivery.loadingSamples,
  updatedSampleTime: sampleDelivery.updatedSampleTime,
  qualityOptions: sampleDelivery.qualityOptions,
  delivery: sampleDelivery.delivery,
  userPermissions: Authorization.permissions,
  generalSettingObject: generalSetting.generalSettingObject,
})

const mapDispatchToProps = dispatch => ({
  onGetDeliverySamples: (deliveryId, callback) => dispatch(getDeliverySamples(deliveryId, callback)),
  onEditDeliverySamples: (sample, callback) => dispatch(updateDeliverySamples({ sample, callback })),
  onMassEditDeliverySamples: (sample, callback) => dispatch(updateMassDeliverySamples({ sample, callback })),
  onCreateDeliverySample: (sample, callback) => dispatch(addDeliverySample({ sample, callback })),
  onDeleteDeliverySample: (samples, callback) => dispatch(deleteDeliverySample({ samples, callback })),
  onGetDeliveryAllTests: payload => dispatch(getDeliveryAllTests(payload)),
  onSearchDeliverySampleDetail: payload => dispatch(searchDeliverySampleDetail(payload)),
  onGetDeliveryDetail: id => dispatch(getDeliveryDetail(id)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation(["deliveryPage", "message", "common"])(TabSample))
